// extracted by mini-css-extract-plugin
module.exports = {"getStartedContainer":"Bottombar_getStartedContainer__2G6cg","getStartedDesc":"Bottombar_getStartedDesc__1lWBT","getStartedButton":"Bottombar_getStartedButton__3yGsw"};